<template>
    <div class="img-load-wrapper" :class="!loaded ? {'skeleton-box': true} : classNamesBox" :style="!loaded ? loadingStyles : {}">
         <img 
              :class="classNames" 
              loading="lazy" 
              decoding="async" 
              :src="srcImg"
              :srcset="srcSet"
              :alt="title"
              @load="imgLoad()"
         />
    </div>
</template>
<script>


export default {
    name: 'LoadImageLazy',
    props:{
        srcImg: String,
        srcSet: {
            type: String,
            default: null
        },
        classNames:{
            type: String,
            default: null
        },
        classNamesBox:{
            type: String,
            default: null
        },
        loadingStyles:{
            type: Object,
            default: () => {
                return {};
            }
        },
        title:{
            type: String,
            default: null
        }
    },
    data(){
        return {
            isLoaded: false,
            visible: false
        }
    },
    computed: {
        loaded(){
            return this.isLoaded && this.srcImg && this.srcImg != '';
        }
    },
    methods: {
        imgLoad(){
            this.isLoaded = true;
        },
    },
}
</script>